import HorizontalProgressBarLegendCount from "./HorizontalProgressBarLegendCount";
import HorizontalProgressRow from "./HorizontalProgressRow"; // NEW
import styles from "./HorizontalProgressChart.module.css";

// dataItems: { [label]: { label, value, color } }
// summaryText: text shown below the total count e.g. "total open"
// title: card heading
// total: (NEW) fixed base for percentages and bar widths (e.g. 723). Defaults to the sum of the items
// variant: (NEW) "default" | "rows". "rows" = label | bar | value + % (no summary block)
// containerProps: spread onto the outer card div
// dataItemProps: spread onto each HorizontalProgressBarLegendCount row wrapper
const HorizontalProgressChart = ({
  title,
  dataItems = {},
  summaryText,
  containerProps,
  dataItemProps,
  isLoading,
  onItemClick,
  total: totalProp, // NEW
  variant = "default", // NEW
}) => {
  const items = Object.values(dataItems);
  const sum = items.reduce((acc, item) => acc + (item.value || 0), 0);
  const total = totalProp ?? sum; // NEW

  // NEW: rows variant
  if (variant === "rows") {
    return (
      <div
        {...containerProps}
        className={[
          styles.container,
          styles.rowsVariantContainer,
          containerProps?.className,
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {title && <h3 className={styles.title}>{title}</h3>}
        <div className={styles.rowsVariant} {...dataItemProps}>
          {items.map((item) => (
            <HorizontalProgressRow
              key={item.label}
              label={item.label}
              value={item.value}
              total={total}
              color={item.color}
              isLoading={isLoading}
              onClick={
                !isLoading && onItemClick ? () => onItemClick(item) : undefined
              }
            />
          ))}
        </div>
      </div>
    );
  }

  // Existing behavior (unchanged apart from `total` now honoring the prop)
  return (
    <div
      {...containerProps}
      className={[styles.container, containerProps?.className].join(" ")}
    >
      {title && <h3 className={styles.title}>{title}</h3>}

      <div className={styles.body}>
        {/* Summary */}
        <div className={styles.summary}>
          <span className={styles.total}>
            {isLoading ? (
              <span
                className="shimmer"
                style={{
                  width: "3rem",
                  height: "2rem",
                  display: "inline-block",
                  borderRadius: "4px",
                }}
              />
            ) : (
              total
            )}
          </span>
          {summaryText && (
            <span className={styles.summaryText}>{summaryText}</span>
          )}
        </div>

        {/* Rows */}
        <div className={styles.rows} {...dataItemProps}>
          {items.map((item) => (
            <HorizontalProgressBarLegendCount
              key={item.label}
              label={item.label}
              value={item.value}
              total={total}
              color={item.color}
              isLoading={isLoading}
              onClick={
                !isLoading && onItemClick ? () => onItemClick(item) : undefined
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HorizontalProgressChart;